import { render, staticRenderFns } from "./MessageInputModal.vue?vue&type=template&id=76b4c550&scoped=true&"
import script from "./MessageInputModal.vue?vue&type=script&lang=ts&"
export * from "./MessageInputModal.vue?vue&type=script&lang=ts&"
import style0 from "./MessageInputModal.vue?vue&type=style&index=0&id=76b4c550&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76b4c550",
  null
  
)

export default component.exports